import { useNavigate } from 'react-router-dom';
import { buildTradePath } from '@formosa/shared/utils/productNavigation';
import ProductListPanel from './ProductListPanel';

/** 首頁搜尋：左側半屏商品列表，右側半透明遮罩可關閉 */
export default function ProductSearchOverlay({ open, onClose }) {
  const navigate = useNavigate();

  if (!open) {
    return null;
  }

  function handleProductClick(product, playType) {
    const path = buildTradePath(playType || product.playType, product.marketSymbolCode);
    onClose?.();
    navigate(path);
  }

  return (
    <div className="product-search-overlay" role="dialog" aria-modal="true" aria-label="全部產品">
      <ProductListPanel
        className="product-search-overlay__panel"
        title="全部產品"
        showClose
        onClose={onClose}
        onProductClick={handleProductClick}
        initialTab="timed"
      />
      <button
        type="button"
        className="product-search-overlay__backdrop"
        aria-label="關閉"
        onClick={onClose}
      />
    </div>
  );
}
